import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VideoService } from '../services/video.service';
import { Exercise } from '../models/exercise';


@Component({
  selector: 'app-video-detail',
  templateUrl: './video-detail.component.html',
  styleUrls: ['./video-detail.component.css']
})
export class VideoDetailComponent implements OnInit {

  private videoList;
  private exerciseId = + this.route.snapshot.paramMap.get('id');
  private bought: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private videoService: VideoService
  ) { }

  ngOnInit() {
    console.log("Video Component Initialized")
    this.getVideoList();

  }

  changeExercise(id){
    this.exerciseId = id;
  }

	getVideoList(){
    this.videoService.getVideoList().then((res:Array<any>)=>{
      console.log(res);
      this.videoList = res;
    });
  }
/*  
  getExercise(): void {
    const id = + this.route.snapshot.paramMap.get('id');
    console.log(id);
    this.videoService.getExercise(id).then((res: any)=>{
      this.exercise = {
        id: res.id,
        title: res.title,
        description: res.description,
        purchaseId: res.purchaseId,
        url: res.url,
        posterUrl: res.url.replace('.mp4','.jpg'),
        price: res.price,
        keyfacts: res.keyfacts
      }
    }).then(()=>{
      this.videoService.checkIfVideoBought(this.exercise).then((isBought)=>{
        if(isBought){
          this.bought = true;
        }
      });
    })
    
  }
*/
}



// WEBPACK FOOTER //
// ./src/app/video-detail/video-detail.component.ts